/**
 * @generated SignedSource<<4364aba45fa0858e8060eff04845acaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticTransactionInfo_subscription$data = {
  readonly comment: string | null | undefined;
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly frequency: string | null | undefined;
  readonly pixRecurring: {
    readonly recurrencyId: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentPixAutomaticTransactionInfo_subscription";
};
export type PaymentPixAutomaticTransactionInfo_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticTransactionInfo_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticTransactionInfo_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticTransactionInfo_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frequency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PixRecurring",
      "kind": "LinkedField",
      "name": "pixRecurring",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recurrencyId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "fdb451afa24e0cccee0462ca494fec87";

export default node;
